
import { IonCard, IonCardHeader, IonCardTitle } from "@ionic/react"

import './WebAppDevProjects.css'

import IdeathonWebsite from './WAProjects/IdeathonWebsite'
import AICRecommender from './WAProjects/AICRecommender'
import WASprout from './WAProjects/WASprout'

function WebAppDevProjects(){

    return(
        <IonCard className = "ion-padding">
          <IonCardHeader>
            <IonCardTitle></IonCardTitle>
          </IonCardHeader>

          <IdeathonWebsite />
          <AICRecommender />
          <WASprout />
        </IonCard>
        
    )
}


export default WebAppDevProjects